import { ReactNode } from "react";
import type { TagProps } from "@/components/Tags/types";
import Tag from "@/components/Tags/Tag";

interface DefaultProps {
  tags?: TagProps[];
  children?: ReactNode;
}

const Default = ({ tags, children }: DefaultProps) => {
  return (
    <div className="flex flex-wrap not-prose gap-2">
      {Array.isArray(tags) &&
        tags.map((tag, index) => (
          <Tag
            key={index}
            {...tag}
            title={tag.text}
            className="my-3 px-3 py-1"
          />
        ))}
      {children}
    </div>
  );
};

export default Default;
